import { agencyApi } from "@/lib/api";

// Fire-and-forget usage telemetry for the agency console (Agency Platform insights).
export function track(type, module = null, dwellMs = 0) {
  if (!localStorage.getItem("mc_agency_token")) return;
  try {
    agencyApi.post("/console/track", { type, module, dwell_ms: Math.round(dwellMs || 0) }).catch(() => {});
  } catch (e) { /* ignore */ }
}
